import {
  accountTypes,
  chargeTypes,
  isNonTransferRetirement
} from '../../flows/shared/utils';

export const isNonTransferIndividualOrTOD = (accountType, chargeType = '') =>
  chargeType !== chargeTypes.TRANSFER &&
  (accountType === accountTypes.INDIVIDUAL || accountType === accountTypes.TOD);

export const isNonTransferRetirementORIndiTOD = (
  accountType,
  chargeType = ''
) =>
  isNonTransferRetirement(accountType) ||
  isNonTransferIndividualOrTOD(accountType, chargeType);

export const isUGMAOrJoint = accountType =>
  accountType === accountTypes.UGMAUTMA || accountType === accountTypes.JOINT;

export const displayExistingAgreementBlockModal = (
  accountType,
  chargeType,
  hasExistingAgree,
  maxedOut
) =>
  !maxedOut &&
  isNonTransferRetirementORIndiTOD(accountType, chargeType) &&
  hasExistingAgree;
